import { render, staticRenderFns } from "./reportWeekProfile.vue?vue&type=template&id=3320bae6&scoped=true&"
import script from "./reportWeekProfile.vue?vue&type=script&lang=js&"
export * from "./reportWeekProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3320bae6",
  null
  
)

export default component.exports